import { __decorate, __param } from 'tslib';
import * as i0 from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as i1 from '@angular/common/http';

/**
 * @NgModule({
 *   providers: [
 *
 *                { provide: 'estoyInteresadoUrl', useValue: 'soy/una/url' },
 *                EstoyInteresadoService
 *   ],
 * })
 *
 */
let EstoyInteresadoService = class EstoyInteresadoService {
    constructor(url, http, prospectoFactory) {
        this.url = url;
        this.http = http;
        this.prospectoFactory = prospectoFactory;
    }
    savePlanInteresado(idProspecto, idSeguro) {
        return this.http
            .post(`${this.url}/prospecto/${idProspecto}/seguro/${idSeguro}/estoy-interesado`, null)
            .pipe(map((response) => {
            return response.respuesta
                ? this.prospectoFactory.convertToModel(response.respuesta)
                : null;
        }));
    }
};
EstoyInteresadoService = __decorate([
    __param(0, Inject('estoyInteresadoUrl'))
], EstoyInteresadoService);

/**
 * @NgModule({
 *   providers: [
 *
 *                { provide: 'prospectoUrl', useValue: 'soy/una/url' },
 *                ProspectoService
 *   ],
 * })
 *
 */
let ProspectoService = class ProspectoService {
    constructor(url, http, prospectoFactory) {
        this.url = url;
        this.http = http;
        this.prospectoFactory = prospectoFactory;
    }
    upsertProspecto(prospecto) {
        return this.http
            .post(`${this.url}/prospecto`, prospecto)
            .pipe(map((response) => {
            return this.prospectoFactory.convertToModel(response.respuesta);
        }));
    }
    getTarifaByIdProspecto(idProspecto) {
        return this.http
            .post(`${this.url}/prospecto/${idProspecto}/tarifa`, null)
            .pipe(map((response) => {
            return this.prospectoFactory.convertToModel(response.respuesta);
        }));
    }
    getUrlPagoByIdProspecto(idProspecto) {
        return this.http
            .post(`${this.url}/prospecto/${idProspecto}/pago`, null)
            .pipe(map((response) => {
            return response.respuesta;
        }));
    }
    getProspectoByIdProspecto(idProspecto) {
        return this.http
            .get(`${this.url}/prospecto/${idProspecto}`)
            .pipe(map((response) => {
            return this.prospectoFactory.convertToModel(response.respuesta);
        }));
    }
};
ProspectoService = __decorate([
    __param(0, Inject('prospectoUrl'))
], ProspectoService);

var Documentos;
(function (Documentos) {
    Documentos["CEDULA_DE_EXTRANJERIA"] = "CE";
    Documentos["P_JURIDICA_SIN_IDENTIFICACION"] = "J";
    Documentos["NIT"] = "NIT";
    Documentos["CEDULA_DE_CIUDADANIA"] = "CC";
    Documentos["DIPLOMATICO"] = "DI";
    Documentos["NUIP"] = "N";
    Documentos["P_NATURAL_SIN_IDENTIFICACION"] = "O";
    Documentos["PASAPORTE"] = "PP";
    Documentos["TARJETA_DE_IDENTIDAD"] = "TI";
    Documentos["REGISTRO_CIVIL"] = "RC";
})(Documentos || (Documentos = {}));

var EstadosProspecto;
(function (EstadosProspecto) {
    EstadosProspecto["ABIERTO"] = "Abierto";
    EstadosProspecto["AT_DATOS_NO_VALIDOS"] = "ConfirmacionDatosNoValida";
    EstadosProspecto["CONVERTIDO"] = "Convertido";
    EstadosProspecto["DESCARTADO"] = "Descartado";
    EstadosProspecto["FALLIDO"] = "Fallido";
    EstadosProspecto["INCOMPLETO"] = "Incompleto";
    EstadosProspecto["VALIDADO"] = "Validado";
    EstadosProspecto["VALIDANDO_REGLAS"] = "ValidandoReglas";
})(EstadosProspecto || (EstadosProspecto = {}));

var EstadosTarifa;
(function (EstadosTarifa) {
    EstadosTarifa["TARIFA_PENDIENTE"] = "TarifaPendiente";
    EstadosTarifa["TARIFA_EN_PROCESO"] = "TarifaEnProceso";
    EstadosTarifa["TARIFA_RECHAZADA"] = "TarifaRechazada";
    EstadosTarifa["TARIFA_FALLIDA"] = "TarifaFallida";
    EstadosTarifa["TARIFA_EXITOSA"] = "TarifaExitosa";
    EstadosTarifa["TARIFA_VENCIDA"] = "TarifaVencida";
})(EstadosTarifa || (EstadosTarifa = {}));

var Genero;
(function (Genero) {
    Genero["MASCULINO"] = "Masculino";
    Genero["FEMENINO"] = "Femenino";
})(Genero || (Genero = {}));

var Parentesco;
(function (Parentesco) {
    Parentesco["CONYUGE"] = "Conyuge";
    Parentesco["PADRES"] = "Padres";
    Parentesco["HIJOS"] = "Hijos";
    Parentesco["HERMANOS"] = "Hermanos";
    Parentesco["ABUELOS"] = "Abuelos";
    Parentesco["SUEGROS"] = "Suegros";
    Parentesco["SOBRINOS"] = "Sobrinos";
    Parentesco["TIOS"] = "Tios";
    Parentesco["NIETOS"] = "Nietos";
    Parentesco["OTROS"] = "Otros";
})(Parentesco || (Parentesco = {}));

var PeriodicidadDePago;
(function (PeriodicidadDePago) {
    PeriodicidadDePago["PAGO_UNICO"] = "PagoUnico";
    PeriodicidadDePago["SEMESTRAL"] = "Semestral";
    PeriodicidadDePago["TRIMESTRAL"] = "Trimestral";
    PeriodicidadDePago["MENSUAL"] = "Mensual";
})(PeriodicidadDePago || (PeriodicidadDePago = {}));

var TipoAsegurado;
(function (TipoAsegurado) {
    TipoAsegurado["ASEGURADO_PRINCIPAL"] = "AseguradoPrincipal";
    TipoAsegurado["ASEGURADO_SECUNDARIO"] = "AseguradoSecundario";
})(TipoAsegurado || (TipoAsegurado = {}));

var TipoBeneficiario;
(function (TipoBeneficiario) {
    TipoBeneficiario["LEGAL"] = "Legal";
    TipoBeneficiario["ONEROSO"] = "Oneroso";
    TipoBeneficiario["PRINCIPAL"] = "Principal";
    TipoBeneficiario["SECUNDARIO"] = "Secundario";
    TipoBeneficiario["GRATUITO"] = "Gratuito";
})(TipoBeneficiario || (TipoBeneficiario = {}));

var TipoDireccion;
(function (TipoDireccion) {
    TipoDireccion["OFICINA_PRINCIPAL"] = "OP";
    TipoDireccion["TRABAJO"] = "TR";
    TipoDireccion["RESIDENCIAL"] = "RS";
    TipoDireccion["OTRA"] = "OT";
    TipoDireccion["CO"] = "CO";
    TipoDireccion["RL"] = "RL";
})(TipoDireccion || (TipoDireccion = {}));

var TipoPersona;
(function (TipoPersona) {
    TipoPersona["NATURAL"] = "PersonaNaturalTemp";
    TipoPersona["JURIDICA"] = "PersonaJuridicaTemp";
})(TipoPersona || (TipoPersona = {}));

var Descuentos;
(function (Descuentos) {
    Descuentos["POR_BONIFICACION"] = "descuentoPorBonificacion";
    Descuentos["POR_USO"] = "descuentoPorUso";
})(Descuentos || (Descuentos = {}));

var Productos;
(function (Productos) {
    Productos["AUTOS"] = "ProductoAutos";
    Productos["AUTOS_ACELERACION_TELEMATICA"] = "ProductoAutosCotizador";
    Productos["BICICLETAS"] = "ProductoBicicletas";
    Productos["MASCOTAS"] = "ProductoMascotas";
    Productos["MOTOS"] = "ProductoMotos";
    Productos["PDP"] = "ProductoProteccionDigitalPersonas";
    Productos["SALUD"] = "ProductoSalud";
    Productos["VIAJES_INTERNACIONAL"] = "ProductoViajesInternacional";
    Productos["VIAJES_NACIONAL"] = "ProductoViajesNacional";
    Productos["VIDA"] = "ProductoVida";
    Productos["SOAT"] = "ProductoSoat";
    Productos["SOAT_RAUC"] = "ProductoSoatRauc";
})(Productos || (Productos = {}));

var KeyUrlPersonalizada;
(function (KeyUrlPersonalizada) {
    KeyUrlPersonalizada["CANAL"] = "canal";
    KeyUrlPersonalizada["ASESOR"] = "asesor";
})(KeyUrlPersonalizada || (KeyUrlPersonalizada = {}));

var NombreProducto;
(function (NombreProducto) {
    NombreProducto["SOAT"] = "soat";
    NombreProducto["PDP"] = "pdp";
    NombreProducto["AUTOS"] = "autos";
    NombreProducto["VIDA"] = "seguro-vida";
    NombreProducto["ARRENDAMIENTO"] = "arrendamiento";
    NombreProducto["MASCOTAS"] = "mascotas";
    NombreProducto["VIAJES"] = "viajes";
    NombreProducto["MOTOS"] = "motos";
    NombreProducto["PLAN_ELIGE"] = "plan elige";
    NombreProducto["BICIS"] = "bicis";
    NombreProducto["SALUD_DIGITAL"] = "salud digital";
})(NombreProducto || (NombreProducto = {}));

var NombreDatoAdicional;
(function (NombreDatoAdicional) {
    NombreDatoAdicional["CODIGO_DESCRIPCION_PAIS_NACIMIENTO"] = "cdPaisNacimiento";
    NombreDatoAdicional["DESCRIPCION_PAIS_NACIMIENTO"] = "dsPaisNacimiento";
    NombreDatoAdicional["CODIGO_DESCRIPCION_PAIS_CONSTITUCION"] = "cdPaisConstitucion";
    NombreDatoAdicional["DESCRIPCION_PAIS_CONSTITUCION"] = "dsPaisConstitucion";
    NombreDatoAdicional["EVIDENCIA_CIFIN"] = "evidenciaCifin";
})(NombreDatoAdicional || (NombreDatoAdicional = {}));

var TipoDeDatoAdicional;
(function (TipoDeDatoAdicional) {
    TipoDeDatoAdicional["STRING"] = "String";
    TipoDeDatoAdicional["INT"] = "Int";
})(TipoDeDatoAdicional || (TipoDeDatoAdicional = {}));

var EstadosDelRiesgo;
(function (EstadosDelRiesgo) {
    EstadosDelRiesgo["ABIERTO"] = "Abierto";
    EstadosDelRiesgo["AT_DATOS_NO_VALIDOS"] = "ConfirmacionDatosNoValida";
    EstadosDelRiesgo["CONVERTIDO"] = "Convertido";
    EstadosDelRiesgo["DESCARTADO"] = "Descartado";
    EstadosDelRiesgo["FALLIDO"] = "Fallido";
    EstadosDelRiesgo["INCOMPLETO"] = "Incompleto";
    EstadosDelRiesgo["VALIDADO"] = "Validado";
    EstadosDelRiesgo["VALIDANDO_REGLAS"] = "ValidandoReglas";
})(EstadosDelRiesgo || (EstadosDelRiesgo = {}));

class PersonaNaturalFactory {
    convertToModel(personaDTO) {
        if (personaDTO === null || personaDTO === undefined) {
            return null;
        }
        return Object.assign(Object.assign({}, personaDTO), { tipoPersona: TipoPersona.NATURAL, fechaNacimiento: personaDTO.fechaNacimiento
                ? new Date(Number(personaDTO.fechaNacimiento))
                : null, fechaExpedicion: personaDTO.fechaExpedicion
                ? new Date(Number(personaDTO.fechaExpedicion))
                : null, ingresosMensuales: personaDTO.ingresosMensuales
                ? Number(personaDTO.ingresosMensuales)
                : null });
    }
    convertToDTO(persona) {
        if (persona === null || persona === undefined) {
            return null;
        }
        return Object.assign(Object.assign({}, persona), { fechaNacimiento: persona.fechaNacimiento
                ? persona.fechaNacimiento.getTime()
                : null, fechaExpedicion: persona.fechaExpedicion
                ? persona.fechaExpedicion.getTime()
                : null, ingresosMensuales: persona.ingresosMensuales
                ? `${persona.ingresosMensuales}`
                : null });
    }
}
PersonaNaturalFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaNaturalFactory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PersonaNaturalFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaNaturalFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaNaturalFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class PersonaJuridicaFactory {
    convertToModel(personaDTO) {
        if (personaDTO === null || personaDTO === undefined) {
            return null;
        }
        return Object.assign(Object.assign({}, personaDTO), { tipoPersona: TipoPersona.JURIDICA, fechaExpedicion: personaDTO.fechaExpedicion
                ? new Date(Number(personaDTO.fechaExpedicion))
                : null });
    }
    convertToDTO(persona) {
        if (persona === null || persona === undefined) {
            return null;
        }
        return Object.assign(Object.assign({}, persona), { fechaExpedicion: persona.fechaExpedicion
                ? persona.fechaExpedicion.getTime()
                : null });
    }
}
PersonaJuridicaFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaJuridicaFactory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PersonaJuridicaFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaJuridicaFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaJuridicaFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class PersonaFactory {
    constructor(personaNaturalFactory, personaJuridicaFactory) {
        this.personaNaturalFactory = personaNaturalFactory;
        this.personaJuridicaFactory = personaJuridicaFactory;
    }
    convertToModel(personaTempDTO) {
        if (personaTempDTO === null || personaTempDTO === undefined) {
            return null;
        }
        const key = Object.keys(personaTempDTO)[0];
        const personaDTO = personaTempDTO[key];
        return key === TipoPersona.NATURAL
            ? this.personaNaturalFactory.convertToModel(personaDTO)
            : this.personaJuridicaFactory.convertToModel(personaDTO);
    }
    convertToDTO(persona) {
        if (persona === null || persona === undefined) {
            return null;
        }
        if (persona.tipoPersona === TipoPersona.NATURAL) {
            return {
                PersonaNaturalTemp: this.personaNaturalFactory.convertToDTO(persona),
            };
        }
        else {
            return {
                PersonaJuridicaTemp: this.personaJuridicaFactory.convertToDTO(persona),
            };
        }
    }
}
PersonaFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaFactory, deps: [{ token: PersonaNaturalFactory }, { token: PersonaJuridicaFactory }], target: i0.ɵɵFactoryTarget.Injectable });
PersonaFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PersonaFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PersonaNaturalFactory }, { type: PersonaJuridicaFactory }]; } });

class BeneficiarioFactory {
    constructor(personaFactory) {
        this.personaFactory = personaFactory;
    }
    convertToModel(beneficiarioDTO) {
        return Object.assign(Object.assign({}, beneficiarioDTO), this.personaFactory.convertToModel(beneficiarioDTO.persona));
    }
    convertToDTO(beneficiario) {
        return Object.assign(Object.assign({}, beneficiario), { persona: this.personaFactory.convertToDTO(beneficiario) });
    }
}
BeneficiarioFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BeneficiarioFactory, deps: [{ token: PersonaFactory }], target: i0.ɵɵFactoryTarget.Injectable });
BeneficiarioFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BeneficiarioFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BeneficiarioFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PersonaFactory }]; } });

class AseguradoFactory {
    constructor(personaFactory, beneficiarioFactory) {
        this.personaFactory = personaFactory;
        this.beneficiarioFactory = beneficiarioFactory;
    }
    convertToModel(aseguradoDTO) {
        return Object.assign(Object.assign({}, this.personaFactory.convertToModel(aseguradoDTO.persona)), { beneficiarios: aseguradoDTO.beneficiarios
                ? aseguradoDTO.beneficiarios.map(beneficiarioDTO => this.beneficiarioFactory.convertToModel(beneficiarioDTO))
                : [], tipoAsegurado: aseguradoDTO.tipoAsegurado, parentesco: aseguradoDTO.parentesco });
    }
    convertToDTO(asegurado) {
        return {
            persona: this.personaFactory.convertToDTO(asegurado),
            tipoAsegurado: asegurado.tipoAsegurado,
            parentesco: asegurado.parentesco,
            beneficiarios: asegurado.beneficiarios
                ? asegurado.beneficiarios.map(beneficiario => this.beneficiarioFactory.convertToDTO(beneficiario))
                : [],
        };
    }
}
AseguradoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AseguradoFactory, deps: [{ token: PersonaFactory }, { token: BeneficiarioFactory }], target: i0.ɵɵFactoryTarget.Injectable });
AseguradoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AseguradoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AseguradoFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PersonaFactory }, { type: BeneficiarioFactory }]; } });

class RiesgoFactory {
    constructor(aseguradoFactory) {
        this.aseguradoFactory = aseguradoFactory;
    }
    convertToModel(riesgoTempDTO) {
        const key = Object.keys(riesgoTempDTO)[0];
        const riesgoDTO = riesgoTempDTO[key];
        return Object.assign(Object.assign({}, riesgoDTO), { asegurados: riesgoDTO.asegurados
                ? riesgoDTO.asegurados.map(aseguradoDTO => this.aseguradoFactory.convertToModel(aseguradoDTO))
                : [] });
    }
}
RiesgoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoFactory, deps: [{ token: AseguradoFactory }], target: i0.ɵɵFactoryTarget.Injectable });
RiesgoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: AseguradoFactory }]; } });

class SeguroFactory {
    constructor(riesgoFactory) {
        this.riesgoFactory = riesgoFactory;
    }
    convertToModel(seguroAEnviar) {
        return Object.assign(Object.assign({}, seguroAEnviar), { fechaInicioVigencia: seguroAEnviar.fechaInicioVigencia
                ? new Date(Number(seguroAEnviar.fechaInicioVigencia))
                : null, fechaFinVigencia: seguroAEnviar.fechaFinVigencia
                ? new Date(Number(seguroAEnviar.fechaFinVigencia))
                : null, riesgos: seguroAEnviar.riesgos
                ? seguroAEnviar.riesgos.map(riesgoAEnviar => this.riesgoFactory.convertToModel(riesgoAEnviar))
                : [] });
    }
}
SeguroFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroFactory, deps: [{ token: RiesgoFactory }], target: i0.ɵɵFactoryTarget.Injectable });
SeguroFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: RiesgoFactory }]; } });

class ProspectoFactory {
    constructor(seguroFactory, personaFactory) {
        this.seguroFactory = seguroFactory;
        this.personaFactory = personaFactory;
    }
    convertToModel(prospectoAEnviar) {
        const seguros = prospectoAEnviar.seguros.map(seguro => this.seguroFactory.convertToModel(seguro));
        return Object.assign(Object.assign({}, prospectoAEnviar), { seguros, fechaCreacion: new Date(Number(prospectoAEnviar.fechaCreacion)), tomador: this.personaFactory.convertToModel(prospectoAEnviar.tomador.persona) });
    }
}
ProspectoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoFactory, deps: [{ token: SeguroFactory }, { token: PersonaFactory }], target: i0.ɵɵFactoryTarget.Injectable });
ProspectoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: SeguroFactory }, { type: PersonaFactory }]; } });

class RiesgoMovilidadFactory {
    constructor(aseguradoFactory) {
        this.aseguradoFactory = aseguradoFactory;
    }
    convertToDTO(riesgo) {
        return {
            RiesgoVehiculoTemp: Object.assign(Object.assign({}, riesgo), { asegurados: riesgo.asegurados.map(asegurado => this.aseguradoFactory.convertToDTO(asegurado)) }),
        };
    }
}
RiesgoMovilidadFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoMovilidadFactory, deps: [{ token: AseguradoFactory }], target: i0.ɵɵFactoryTarget.Injectable });
RiesgoMovilidadFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoMovilidadFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RiesgoMovilidadFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: AseguradoFactory }]; } });

class SeguroVehiculoFactory {
    constructor(riesgoFactory) {
        this.riesgoFactory = riesgoFactory;
    }
    convertToDTO(seguro) {
        return Object.assign(Object.assign({}, seguro), { fechaInicioVigencia: seguro.fechaInicioVigencia
                ? seguro.fechaInicioVigencia.getTime()
                : null, fechaFinVigencia: seguro.fechaFinVigencia
                ? seguro.fechaFinVigencia.getTime()
                : null, riesgos: seguro.riesgos.map(riesgo => this.riesgoFactory.convertToDTO(riesgo)) });
    }
}
SeguroVehiculoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroVehiculoFactory, deps: [{ token: RiesgoMovilidadFactory }], target: i0.ɵɵFactoryTarget.Injectable });
SeguroVehiculoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroVehiculoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeguroVehiculoFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: RiesgoMovilidadFactory }]; } });

class ProspectoVehiculoFactory {
    constructor(seguroFactory, personaFactory) {
        this.seguroFactory = seguroFactory;
        this.personaFactory = personaFactory;
    }
    convertToDTO(prospecto) {
        const seguros = prospecto.seguros.map(seguro => this.seguroFactory.convertToDTO(seguro));
        return Object.assign(Object.assign({}, prospecto), { seguros, fechaCreacion: prospecto.fechaCreacion.getTime(), tomador: {
                persona: prospecto.tomador
                    ? this.personaFactory.convertToDTO(prospecto.tomador)
                    : null,
            } });
    }
}
ProspectoVehiculoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoVehiculoFactory, deps: [{ token: SeguroVehiculoFactory }, { token: PersonaFactory }], target: i0.ɵɵFactoryTarget.Injectable });
ProspectoVehiculoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoVehiculoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProspectoVehiculoFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: SeguroVehiculoFactory }, { type: PersonaFactory }]; } });

class ValidacionesService {
    constructor(http, prospectoFactory, urlApi) {
        this.http = http;
        this.prospectoFactory = prospectoFactory;
        this.urlApi = urlApi;
    }
    executeValidations(prospecto) {
        return this.http
            .post(`${this.urlApi}${ValidacionesService.VALIDACIONES_ENDPOINT}`, prospecto)
            .pipe(map((response) => {
            return this.prospectoFactory.convertToModel(response.respuesta);
        }), catchError(err => {
            console.error(err);
            return throwError(err);
        }));
    }
}
ValidacionesService.VALIDACIONES_ENDPOINT = '/validaciones-core';
ValidacionesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ValidacionesService, deps: [{ token: i1.HttpClient }, { token: ProspectoFactory }, { token: 'validationsUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
ValidacionesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ValidacionesService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ValidacionesService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: ProspectoFactory }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['validationsUrl']
                }] }]; } });

class AbstractProspectoEffect {
}

class PersonaNaturalBuilder {
    constructor() {
        this.tipoPersona = TipoPersona.NATURAL;
    }
    withPrimerNombre(primerNombre) {
        this.primerNombre = primerNombre;
        return this;
    }
    withSegundoNombre(segundoNombre) {
        this.segundoNombre = segundoNombre;
        return this;
    }
    withPrimerApellido(primerApellido) {
        this.primerApellido = primerApellido;
        return this;
    }
    withSegundoApellido(segundoApellido) {
        this.segundoApellido = segundoApellido;
        return this;
    }
    withGenero(genero) {
        this.genero = genero;
        return this;
    }
    withDireccion(direccion) {
        this.direccion = direccion;
        return this;
    }
    withCodigoCiudad(codigoCiudad) {
        this.codigoCiudad = codigoCiudad;
        return this;
    }
    withCiudad(ciudad) {
        this.ciudad = ciudad;
        return this;
    }
    withCelular(celular) {
        this.celular = celular;
        return this;
    }
    withTelefono(telefono) {
        this.telefono = telefono;
        return this;
    }
    withOcupacion(ocupacion) {
        this.ocupacion = ocupacion;
        return this;
    }
    withFechaNacimiento(fechaNacimiento) {
        this.fechaNacimiento = fechaNacimiento;
        return this;
    }
    withCodigoDepartamento(codigoDepartamento) {
        this.codigoDepartamento = codigoDepartamento;
        return this;
    }
    withDepartamento(departamento) {
        this.departamento = departamento;
        return this;
    }
    withEps(eps) {
        this.eps = eps;
        return this;
    }
    withTipoIdentificacion(tipoIdentificacion) {
        this.tipoIdentificacion = tipoIdentificacion;
        return this;
    }
    withNumeroIdentificacion(numeroIdentificacion) {
        this.numeroIdentificacion = numeroIdentificacion;
        return this;
    }
    withCorreo(correo) {
        this.correo = correo;
        return this;
    }
    withFechaExpedicion(fechaExpedicion) {
        this.fechaExpedicion = fechaExpedicion;
        return this;
    }
    withTipoPersona(tipoPersona) {
        this.tipoPersona = tipoPersona;
        return this;
    }
    withDatosAdicionales(datosAdicionales) {
        this.datosAdicionales = datosAdicionales;
        return this;
    }
    build() {
        return {
            primerNombre: this.primerNombre,
            segundoNombre: this.segundoNombre,
            primerApellido: this.primerApellido,
            segundoApellido: this.segundoApellido,
            genero: this.genero,
            direccion: this.direccion,
            codigoCiudad: this.codigoCiudad,
            ciudad: this.ciudad,
            celular: this.celular,
            telefono: this.telefono,
            ocupacion: this.ocupacion,
            fechaNacimiento: this.fechaNacimiento,
            codigoDepartamento: this.codigoDepartamento,
            departamento: this.departamento,
            eps: this.eps,
            tipoIdentificacion: this.tipoIdentificacion,
            numeroIdentificacion: this.numeroIdentificacion,
            correo: this.correo,
            fechaExpedicion: this.fechaExpedicion,
            tipoPersona: this.tipoPersona,
            datosAdicionales: this.datosAdicionales,
        };
    }
}

class RiesgoBuilder {
    constructor() {
        this.asegurados = [];
        this.valorAsegurable = null;
        this.tarifas = null;
        this.gruposCoberturas = null;
    }
    withAsegurados(asegurados) {
        this.asegurados = asegurados;
        return this;
    }
    withValorAsegurable(valorAsegurable) {
        this.valorAsegurable = valorAsegurable;
        return this;
    }
    withTarifas(tarifas) {
        this.tarifas = tarifas;
        return this;
    }
    withId(id) {
        this._id = id;
        return this;
    }
    withTipoRiesgo(tipoRiesgo) {
        this.tipoRiesgo = tipoRiesgo;
        return this;
    }
    withGruposDeCoberturas(gruposCoberturas) {
        this.gruposCoberturas = gruposCoberturas;
        return this;
    }
    withEstado(estado) {
        this.estado = estado;
        return this;
    }
    build() {
        return {
            asegurados: this.asegurados,
            valorAsegurable: this.valorAsegurable,
            tarifas: this.tarifas,
            _id: this._id,
            tipoRiesgo: this.tipoRiesgo,
            gruposCoberturas: this.gruposCoberturas,
            estado: this.estado,
        };
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractProspectoEffect, AseguradoFactory, BeneficiarioFactory, Descuentos, Documentos, EstadosDelRiesgo, EstadosProspecto, EstadosTarifa, EstoyInteresadoService, Genero, KeyUrlPersonalizada, NombreDatoAdicional, NombreProducto, Parentesco, PeriodicidadDePago, PersonaFactory, PersonaJuridicaFactory, PersonaNaturalBuilder, PersonaNaturalFactory, Productos, ProspectoFactory, ProspectoService, ProspectoVehiculoFactory, RiesgoBuilder, RiesgoFactory, RiesgoMovilidadFactory, SeguroFactory, SeguroVehiculoFactory, TipoAsegurado, TipoBeneficiario, TipoDeDatoAdicional, TipoDireccion, TipoPersona, ValidacionesService };
